<!-- Header Start -->
<div class="cal-header">
  <button (click)="monthBack()">
    <mat-icon class="cal-icons">arrow_back</mat-icon>
  </button>
  <span class="cal-heading">{{initialDate | date:'MMMM y'}}</span>
  <button (click)="monthForward()">
    <mat-icon class="cal-icons">arrow_forward</mat-icon>
  </button>
</div>
<!-- Header End -->

<!-- Divider Start -->
<div class="cal-divider"></div>
<!-- Divider Start -->

<!-- Legends Start -->
<div class="cal-legends">
  <div class="cal-legend">
    <div class="cal-ellipse cal-ellipse-1"></div>
    <span class="cal-legend-text">Appointment</span>
  </div>
  <div class="cal-legend">
    <div class="cal-ellipse cal-ellipse-2"></div>
    <span class="cal-legend-text">Multiple appointments</span>
  </div>
  <div class="cal-legend">
    <div class="cal-ellipse cal-ellipse-3"></div>
    <span class="cal-legend-text">Due</span>
  </div>
</div>
<!-- Legends End -->

<!-- WeekDay List Start -->
<table class="weekday-table">
  <tr>
    <th class="weekday-cell">SUN</th>
    <th class="weekday-cell">MON</th>
    <th class="weekday-cell">TUE</th>
    <th class="weekday-cell">WED</th>
    <th class="weekday-cell">THU</th>
    <th class="weekday-cell">FRI</th>
    <th class="weekday-cell">SAT</th>
  </tr>
</table>
<!-- WeekDay List End -->

<!-- Date List Start -->
<table class="weekday-table" *ngIf="!loading">
  <tr *ngFor='let dates of datesList'>
    <th *ngFor='let date of dates' [ngClass]="getDateClasses(date)">
      <button (click)="selectDate(date)">{{date}}</button>
    </th>
  </tr>
</table>
<!-- Date List End -->

<div class="row my-5" *ngIf="loading">
  <div class="spinner-border loader" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>